//export const prepschoolLiveClassArena = 'http://localhost:3001';
export const prepschoolLiveClassArena = process.env.REACT_APP_LIVE_CLASS_SERVICE;
